import React from 'react';
import { Invitation } from 'hooks/requests/invitations/invitations.types';

export const InvitationContext = React.createContext<Invitation | undefined>(undefined);
